export { default as FormDetail } from "./FormDetail.vue";
export { default as FormMutate } from "./FormMutate.vue";
